<div class="frame-in">
    <div id="game-holder"></div>
</div>
